// 視認性テスト用のデバッグメニュー。バッククォート( ` )キーでトグル。
// 天気 / 時刻 / 環境プリセット / 明るさ(露出) を手動で固定・変更できる。
// main.ts のローカル状態には触れず、window グローバル経由で疎結合に操作する。
//   window.__setRain(on)        天気(雨/晴れ)
//   window.__time               時計 { t, dayLength, speed }
//   window.__applyPreset(name)  環境プリセット sunset/moonlit/storm/dusk/arctic/foggy/seaOfThieves/blackFlag
//   window.__dbgWeatherLock     天気の自動切替を止める
//   window.__dbgPresetLock      昼夜プリセットの自動切替を止める
//   window.__dbgPresetUnsafe    true で切替の安全窓を閉じる(先送り動作の検証用)
//   window.__dbgExposure        明るさ(CSS brightness)を上書き。null で自動に戻す

const W = window as any;
let panel: HTMLDivElement | null = null;

function applyExposure(v: number): void { W.__dbgExposure = v; }
function currentExposure(): number { return W.__dbgExposure ?? 1; }
function setTimeHour(hour: number): void { const c = W.__time; if (c) c.t = c.dayLength * (hour / 24); }
function currentHour(): number { const c = W.__time; return c ? (c.t / c.dayLength) * 24 : 10; }

function btn(label: string, onClick: () => void): HTMLButtonElement {
  const b = document.createElement('button');
  b.textContent = label;
  b.style.cssText = 'padding:5px 10px;margin:0 4px 4px 0;border:0;border-radius:6px;background:#2a3550;color:#fff;font-size:12px;cursor:pointer';
  b.onmouseenter = () => (b.style.background = '#3a4a70');
  b.onmouseleave = () => (b.style.background = '#2a3550');
  b.onclick = onClick;
  return b;
}
function section(title: string): HTMLDivElement {
  const d = document.createElement('div');
  d.style.cssText = 'margin:0 0 12px';
  const t = document.createElement('div');
  t.textContent = title;
  t.style.cssText = 'font-size:11px;color:#9fb3d9;margin:0 0 5px;letter-spacing:.04em';
  d.appendChild(t);
  return d;
}
function checkbox(label: string, checked: boolean, onChange: (v: boolean) => void): HTMLLabelElement {
  const l = document.createElement('label');
  l.style.cssText = 'display:inline-flex;align-items:center;gap:5px;font-size:12px;cursor:pointer;margin-right:12px';
  const c = document.createElement('input');
  c.type = 'checkbox';
  c.checked = checked;
  c.onchange = () => onChange(c.checked);
  l.appendChild(c);
  l.appendChild(document.createTextNode(label));
  return l;
}
function slider(min: number, max: number, step: number, val: number, onInput: (v: number) => void): HTMLInputElement {
  const s = document.createElement('input');
  s.type = 'range';
  s.min = String(min); s.max = String(max); s.step = String(step); s.value = String(val);
  s.style.cssText = 'width:180px;vertical-align:middle';
  s.oninput = () => onInput(parseFloat(s.value));
  return s;
}

function build(): void {
  panel = document.createElement('div');
  panel.id = 'dbg-panel';
  panel.style.cssText =
    'position:fixed;left:16px;bottom:70px;z-index:2147483646;background:rgba(12,18,32,.92);color:#fff;' +
    'padding:14px 16px;border-radius:12px;font-family:system-ui,sans-serif;pointer-events:auto;' +
    'box-shadow:0 6px 24px rgba(0,0,0,.5);border:1px solid rgba(255,255,255,.08);min-width:230px';

  const head = document.createElement('div');
  head.innerHTML = '<b>🛠 デバッグ</b> <span style="color:#7f8db0;font-size:11px">( ` で開閉 )</span>';
  head.style.cssText = 'font-size:13px;margin:0 0 12px';
  panel.appendChild(head);

  const wSec = section('天気');
  wSec.appendChild(btn('☀️ 晴れ', () => W.__setRain?.(false)));
  wSec.appendChild(btn('🌧 雨', () => W.__setRain?.(true)));
  wSec.appendChild(document.createElement('br'));
  wSec.appendChild(checkbox('自動切替をロック', !!W.__dbgWeatherLock, (v) => (W.__dbgWeatherLock = v)));
  panel.appendChild(wSec);

  const pSec = section('環境プリセット(空・明るさの本体)');
  pSec.appendChild(btn('🌇 sunset', () => W.__applyPreset?.('sunset')));
  pSec.appendChild(btn('🌙 moonlit', () => W.__applyPreset?.('moonlit')));
  pSec.appendChild(btn('⛈ storm', () => W.__applyPreset?.('storm')));
  pSec.appendChild(btn('🌅 dusk', () => W.__applyPreset?.('dusk')));
  pSec.appendChild(btn('❄️ arctic', () => W.__applyPreset?.('arctic')));
  pSec.appendChild(btn('🌫 foggy', () => W.__applyPreset?.('foggy')));
  pSec.appendChild(btn('🏝 seaOfThieves', () => W.__applyPreset?.('seaOfThieves')));
  pSec.appendChild(btn('🏴‍☠️ blackFlag', () => W.__applyPreset?.('blackFlag')));
  pSec.appendChild(document.createElement('br'));
  pSec.appendChild(checkbox('自動切替をロック', !!W.__dbgPresetLock, (v) => (W.__dbgPresetLock = v)));
  panel.appendChild(pSec);

  const tSec = section('時刻');
  const hourLabel = document.createElement('span');
  hourLabel.style.cssText = 'font-size:12px;margin-left:8px;color:#cfe';
  const updHour = () => { hourLabel.textContent = `${currentHour().toFixed(1)}時`; };
  tSec.appendChild(slider(0, 24, 0.25, currentHour(), (v) => { setTimeHour(v); updHour(); }));
  updHour();
  tSec.appendChild(hourLabel);
  tSec.appendChild(document.createElement('br'));
  tSec.appendChild(checkbox('時間を止める(speed=0)', W.__time?.speed === 0, (v) => { if (W.__time) W.__time.speed = v ? 0 : 1; }));
  panel.appendChild(tSec);

  const eSec = section('明るさ(露出)');
  const expLabel = document.createElement('span');
  expLabel.style.cssText = 'font-size:12px;margin-left:8px;color:#fe9';
  const updExp = () => { expLabel.textContent = W.__dbgExposure == null ? '自動' : `×${currentExposure().toFixed(2)}`; };
  const eSlider = slider(1, 2.5, 0.05, currentExposure(), (v) => { applyExposure(v); updExp(); });
  updExp();
  eSec.appendChild(eSlider);
  eSec.appendChild(expLabel);
  eSec.appendChild(document.createElement('br'));
  eSec.appendChild(btn('自動に戻す', () => { W.__dbgExposure = null; eSlider.value = '1'; updExp(); }));
  panel.appendChild(eSec);

  document.body.appendChild(panel);
}

function toggle(): void {
  if (panel) { panel.remove(); panel = null; } else { build(); }
}

addEventListener('keydown', (e) => {
  const t = e.target as HTMLElement;
  if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
  if (e.code === 'Backquote') { e.preventDefault(); toggle(); }
});

// タイトル画面/スマホ用: 画面右上に常時タップできるトグルボタン(🛠)。
// ゲーム起動でDOMが差し替わっても消えないよう、短時間リトライで確実に設置する。
function mountToggleButton(): void {
  if (!document.body) return;
  // 製品UIには露出させない: side6-debug フラグか ?debug 付きURLの時だけ表示(` キーは常時有効)
  try { if (!localStorage.getItem('side6-debug') && !location.search.includes('debug')) return; } catch { return; }
  if (document.getElementById('dbg-toggle')) return;
  const b = document.createElement('button');
  b.id = 'dbg-toggle';
  b.textContent = '🛠';
  b.title = 'デバッグメニュー ( ` キー )';
  b.style.cssText =
    'position:fixed;top:62px;right:14px;z-index:2147483647;width:40px;height:40px;padding:0;' +
    'border:0;border-radius:8px;background:rgba(12,18,32,.82);color:#fff;font-size:20px;' +
    'cursor:pointer;pointer-events:auto;box-shadow:0 2px 10px rgba(0,0,0,.5)';
  b.onclick = (e) => { e.preventDefault(); e.stopPropagation(); toggle(); };
  b.addEventListener('touchend', (e) => { e.preventDefault(); toggle(); }, { passive: false });
  // ⚙設定ボタンと同じ親・同じDOM順(すぐ後ろ)に差し込み、同じクリック可能コンテキストに乗せる
  const gear = document.getElementById('gfxBtn')
    || [...document.querySelectorAll('button')].find((x) => (x.textContent || '').includes('⚙'));
  if (gear && gear.parentElement) gear.insertAdjacentElement('afterend', b);
  else document.body.appendChild(b);
}
mountToggleButton();
addEventListener('DOMContentLoaded', mountToggleButton);
addEventListener('load', mountToggleButton);
let _dbgMountTries = 0;
const _dbgMountIv = setInterval(() => { mountToggleButton(); if (++_dbgMountTries > 20) clearInterval(_dbgMountIv); }, 300);

export {};
